import { CheckCircle2, Loader2, AlertTriangle, Clock } from "lucide-react";

const fmtTime = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
};

/** Banner bloccante: connessione Meta rotta → l'utente deve riautorizzare.
 *  Evita che dati fermi sembrino semplicemente "aggiornati". */
export const AdsReconnectBanner = ({ sync, message, testid = "ads-reconnect-banner" }) => {
  if (!sync?.auth?.reconnect_required) return null;
  return (
    <div data-testid={testid}
      className="rounded-xl border border-rose-200 bg-rose-50 p-3 flex items-start gap-2 text-sm text-rose-800">
      <AlertTriangle className="h-4 w-4 flex-shrink-0 mt-0.5" />
      <span className="font-bold">
        {message || "Connessione Meta scaduta. Riconnetti Meta per aggiornare i dati Ads."}
      </span>
    </div>
  );
};

/** Freschezza dati Meta: timestamp dell'ultimo intraday sync RIUSCITO (server-side),
 *  mai l'orario del browser. */
export const AdsFreshness = ({ sync, className = "" }) => {
  const t = fmtTime(sync?.data_updated_at);
  if (!t) return null;
  const broken = !!sync?.auth?.reconnect_required;
  return (
    <p data-testid="ads-freshness" className={`inline-flex items-center gap-1 text-xs ${broken ? "text-rose-600 font-bold" : "text-[color:var(--sp-text-muted)]"} ${className}`}>
      <Clock className="h-3 w-3" /> Dati Meta aggiornati alle {t}{broken ? " · connessione Meta da riconnettere" : ""}
    </p>
  );
};

const HIST = {
  complete: { label: "Storico completo", tone: "emerald", Icon: CheckCircle2 },
  syncing: { label: "Storico in sync", tone: "sky", Icon: Loader2 },
  partial: { label: "Storico parziale", tone: "amber", Icon: AlertTriangle },
  error: { label: "Storico in errore", tone: "rose", Icon: AlertTriangle },
  not_started: { label: "Storico da avviare", tone: "slate", Icon: Clock },
};
const TONE = {
  emerald: "bg-emerald-100 text-emerald-700",
  sky: "bg-sky-100 text-sky-700",
  amber: "bg-amber-100 text-amber-700",
  rose: "bg-rose-100 text-rose-700",
  slate: "bg-slate-100 text-slate-600",
};

const AUTH_BROKEN = { label: "Riconnetti Meta", tone: "rose", Icon: AlertTriangle };

/** Badge tecnico (solo Agency): stato dei tre sync + coverage certificata. */
export const AdsSyncBadge = ({ sync, testid = "ads-sync-badge" }) => {
  if (!sync?.eligible && !sync?.auth?.reconnect_required) return null;
  const h = sync.history || {};
  const meta = sync?.auth?.reconnect_required ? AUTH_BROKEN : (HIST[h.status] || HIST.not_started);
  const pct = !sync?.auth?.reconnect_required && (h.status === "syncing" || h.status === "partial") ? ` ${h.progress_pct || 0}%` : "";
  const coverage = h.synced_from && h.synced_through ? `${h.synced_from} → ${h.synced_through}` : "non certificata";
  const title = [
    `Intraday: ${fmtTime(sync.intraday?.last_success_at) || "—"}`,
    `Reconciliation: ${fmtTime(sync.daily?.last_success_at) || "—"}`,
    `Coverage: ${coverage}`,
    h.last_error ? `Errore: ${h.last_error}` : null,
  ].filter(Boolean).join(" · ");
  return (
    <span data-testid={testid} title={title}
      className={`inline-flex items-center gap-1 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${TONE[meta.tone]}`}>
      <meta.Icon className={`h-2.5 w-2.5 ${h.status === "syncing" ? "animate-spin" : ""}`} />
      {meta.label}{pct}
    </span>
  );
};
